import React from 'react';
import changeProviderProvider from 'mn-utils/changeProviderProvider';
import handleProviderProvider from 'mn-utils/changeProviderProviderSimple';
import withReDelay from 'mn-utils/withReDelay';
import noop from 'mn-utils/noop';
import every from 'mn-utils/every';
import find from 'mn-utils/find';
import reduce from 'mn-utils/reduce';
import RefreshIcon from '@material-ui/icons/Refresh';
import {
  LINK_ADMIN_PAYOUT_NIUM_REMITTERS,
} from '../../../../../constants/links';
import {
  Link,
  pushLocation,
} from '../../../../../router';
import {
  COUNTRIES_UPPERCASE,
} from '../../../../../constants/countries';
import Select from '../../../../dumb/Select/D';
import Select2 from '../../../../dumb/Select/F';
import Select3 from '../../../../dumb/Select/B';
import ButtonQ from '../../../../dumb/Button/Q';
import CheckboxB from '../../../../dumb/Checkbox/B';
import LayoutA from '../../../../dumb/Layout/A';
import Caption from '../../../../dumb/Caption/A';
import HeaderA from '../../../../dumb/Header/A';
import ButtonUp from '../../../../dumb/Button/Up';
import Tooltip from '../../../../dumb/Tooltip/A';
import RowA from '../../../../dumb/Row/A';
import ColA2 from '../../../../dumb/Col/A2';
import ColA from '../../../../dumb/Col/A';
import RowB from '../../../../dumb/Row/B';
import ColB from '../../../../dumb/Col/B';
import ColB2 from '../../../../dumb/Col/B2';
import Ripple from '../../../../dumb/Ripple';
import WrapperWithLoading from '../../../../dumb/WrapperWithLoading';
import ButtonD from '../../../../dumb/Button/D';
import SendMoneyIcon from '../../../../icons/SendMoney';
import PaymentIcon from '../../../../icons/Payment';
import PencilIcon from '../../../../icons/Pencil';
import Popup from '../../../../dumb/Popup/C';
import TextField from '../../../../dumb/TextField/H';
import virtualOutputComponentProvider from '../../../../../utils/virtualOutputComponentProvider';
import {
  apiAdminPayoutMerchantList,
} from '../../../../../api/admin/payout';
import {apiAdminPayoutNiumGroupCreate} from '../../../../../api/admin/payout/nium';
import {
  apiAdminPayoutNiumBeneficiaryAdd,
  apiAdminPayoutNiumBeneficiaryGet,
} from '../../../../../api/admin/payout/nium/beneficiary';
import {apiAdminPayoutVertoIndividualCreate} from '../../../../../api/admin/payout/verto';
import {
  openV1PopupInfo,
  openPopupWindow,
} from '../../../../../emitters/popup';
import formatTime, {
  getRFC3339,
} from 'mn-utils/formatTime';
import {
  CURRENCY_EUR,
  CURRENCY_ITEMS,
} from '../../../../../constants';
import {TableNumberColAmin} from "../../../../dumb/TableNumberCol";
import * as links from "../../../../../constants/links";
import FieldC from "../../../../dumb/Field/A";

const {
  DisplayIdAdmin,
  DisplayDataAdmin,
  DisplayAmountAdmin,
  DisplayDateTimeAdmin
} = require("../../../../dumb/DisplayData");

module.exports = virtualOutputComponentProvider({
  state: {
    currency: CURRENCY_EUR,
  },
  rowHeight: 70,
  request: apiAdminPayoutMerchantList,
  getParams: (self) => {
    const state = self.state || {};
    return {
      fiat_code: state.currency,
    };
  },
  wrapper(render, setState, self) {
    const update = withReDelay(self.update, 100);

    const openWithdrawalWindow = (merchants) => {
      openPopupWindow((setPopupState, popup) => {
        const {close} = popup;

        const {merchantIds, total} = merchants.reduce((acc, merchant) => {
          acc.total += +merchant.available_amount;
          acc.merchantIds.push(merchant.merchant_id);
          return acc;
        }, {merchantIds: [], total: 0});

        const verto = 'Verto';
        const nium = 'Nium';

        popup.state = {
          clicked: false,
          merchantIds,
          total,
          system: nium,
          amount: total || 0,
        };

        const handleProvider = changeProviderProvider(setPopupState);
        // const changeProvider = handleProviderProvider(setPopupState);
        const handleChangeAmount = handleProvider('amount');
        // const handleChangeAssetCode = changeProvider('assetCode');

        return (stateOfPopup) => {
          const {
            amount,
            total,
            system
          } = stateOfPopup;
          const isMultipleMerchants = merchants.length > 1;

          const amountNotSet = !amount;
          const amountBelowZeroSet = amount < 0;
          const amountAboveMax = amount > total;
          const amountError = amountNotSet || amountBelowZeroSet || amountAboveMax;

          return (
            <Popup
              caption={(
                <div className="layoutRow fhaS fvaC w">
                  <div>Are you sure you want to pay {isMultipleMerchants ? 'these merchants' : 'this merchant'}?</div>
                </div>
              )}
              onCancel={close}
              disabled={!stateOfPopup.system}
              text={isMultipleMerchants ? 'Withdrawal all' : 'Withdrawal'}
              onSave={() => {
                setPopupState({
                  loading: true,
                  system: '',
                });

                apiAdminPayoutNiumGroupCreate({
                  ids: merchantIds,
                  amount,
                  system,
                  fiat_code: self.state.currency,
                }).finally((error) => {
                  setPopupState({
                    loading: false,
                  });
                  if (error) {
                    return;
                  }

                  update();
                  const msg = (isMultipleMerchants ? 'Withdrawal all' : 'Withdraw') + ' is success!';
                  openV1PopupInfo([msg]);
                  close();
                });
              }}
            >
              <WrapperWithLoading
                loading={stateOfPopup.loading}
              >
                <Select3
                  className="mt20 wmax471 mr10>1"
                  label="Asset code"
                  propName="id"
                  propValue="id"
                  value={system}
                  items={[{id: nium}, {id: verto}]}
                  disabled
                />
                {/*<TextField*/}
                {/*  className="mt30 wmax471 mr10>1"*/}
                {/*  label="Payment amount"*/}
                {/*  value={amount}*/}
                {/*  onChange={handleChangeAmount}*/}
                {/*  error={stateOfPopup.clicked && amountError}*/}
                {/*  disabled={isMultipleMerchants}*/}
                {/*  helperText={*/}
                {/*    amountNotSet*/}
                {/*      ? 'Required field'*/}
                {/*      : amountBelowZeroSet*/}
                {/*        ? 'Amount must be higher than 0'*/}
                {/*        : amountAboveMax*/}
                {/*          ? `Amount must less or equal ${total}`*/}
                {/*          : ''*/}
                {/*  }*/}
                {/*/>*/}
                {/*{merchants.map((merchant) => (*/}
                {/*  <div key={merchant.email} className="f20 mt20">*/}
                {/*    {merchant.name || merchant.email}: <b>{merchant.available_amount} {merchant.currency}</b>*/}
                {/*  </div>*/}
                {/*))}*/}
                {/*{isMultipleMerchants ? (*/}
                {/*  <div>*/}
                {/*    <hr className="mb25"/>*/}
                {/*    <span className="f22">*/}
                {/*      Total: <b>{total} {merchants[0].currency}</b>*/}
                {/*    </span>*/}
                {/*  </div>*/}
                {/*) : null}*/}
              </WrapperWithLoading>
            </Popup>
          );
        };
      });
    };

    const openDetailsWindow = async (merchantId) => {
      const beneficiary = await apiAdminPayoutNiumBeneficiaryGet({merchant_id: merchantId}) || {};
      openPopupWindow((setPopupState, popup) => {
        const {
          close,
        } = popup;

        if (!beneficiary.bank_name) {
          return () => (
            <Popup
              caption={(
                <div>
                  <span className="cRed">Error! Bank data is missing.</span>
                </div>
              )}
              onCancel={close}
              disabled
            >
              <p className="wmax910 mv20">
                Payout data of {merchantId} hasn't been set yet. Please go to <Link className="c5B47FF tdN o75:h"
                  href={`${links.LINK_ADMIN_PAYOUT}/${merchantId}`}>edit
                page</Link> and add bank details
              </p>
            </Popup>
          );
        }

        popup.state = {
          clicked: false,
          name: beneficiary.name,
          countryCode: beneficiary.country_code,
          accountNumber: beneficiary.account_number,
          bankName: beneficiary.bank_name,
          bankCode: beneficiary.bank_code,
          routingCodeType1: beneficiary.routing_code_type_1,
          routingCodeValue1: beneficiary.routing_code_value_1,
          routingCodeType2: beneficiary.routing_code_type_2,
          routingCodeValue2: beneficiary.routing_code_value_2,
          routingCodeType3: beneficiary.routing_code_type_3,
          routingCodeValue3: beneficiary.routing_code_value_3,
        };

        const handleProvider = changeProviderProvider(setPopupState);
        const handleChangeCountryCode = handleProviderProvider(setPopupState)('countryCode');
        const handleChangeAccountNumber = handleProvider('accountNumber');
        const handleChangeBankName = handleProvider('bankName');
        const handleChangeBankCode = handleProvider('bankCode');
        const handleChangeRoutingCodeType1 = handleProvider('routingCodeType1');
        const handleChangeRoutingCodeValue1 = handleProvider('routingCodeValue1');
        const handleChangeRoutingCodeType2 = handleProvider('routingCodeType2');
        const handleChangeRoutingCodeValue2 = handleProvider('routingCodeValue2');
        const handleChangeRoutingCodeType3 = handleProvider('routingCodeType3');
        const handleChangeRoutingCodeValue3 = handleProvider('routingCodeValue3');

        return (stateOfPopup) => {
          const {
            name,
            countryCode,
            accountNumber,
            bankName,
            bankCode,
            routingCodeType1,
            routingCodeValue1,
            routingCodeType2,
            routingCodeValue2,
            routingCodeType3,
            routingCodeValue3,
          } = stateOfPopup;

          return (
            <Popup
              caption={(
                <div className="layoutRow fhaS fvaC w">
                  <div>Edit Merchant Bank Account</div>
                  <div className="mh30 fw3 rlv st-2">|</div>
                  <div className="f12 fx1 wmin0 tov ov wsNW">{name}</div>
                </div>
              )}
              onCancel={close}
              disabled={stateOfPopup.clicked} // TODO: validation
              // disabled={stateOfPopup.clicked && invalidAssetAmount}
              onSave={() => {
                // if (invalidAssetAmount) {
                //   setPopupState({
                //     clicked: true,
                //   });
                //   return;
                // }

                setPopupState({
                  loading: true,
                });

                const params = {
                  ...beneficiary, ...{
                    country_code: countryCode,
                    account_number: accountNumber,
                    bank_name: bankName,
                    bank_code: bankCode,
                    routing_code_type_1: routingCodeType1,
                    routing_code_value_1: routingCodeValue1,
                    routing_code_type_2: routingCodeType2,
                    routing_code_value_2: routingCodeValue2,
                    routing_code_type_3: routingCodeType3,
                    routing_code_value_3: routingCodeValue3,
                  },
                };
                apiAdminPayoutNiumBeneficiaryAdd(params).finally((error) => {
                  setPopupState({
                    loading: false,
                  });
                  if (error) {
                    return;
                  }
                  update();
                  openV1PopupInfo(['Bank details has been updated']);
                  close();
                });
              }}
            >
              <WrapperWithLoading
                loading={stateOfPopup.loading}
              >
                {bankName
                  ? (
                    <>
                      <TextField
                        className="mt20 wmax472"
                        label="Bank name"
                        value={bankName}
                        disabled
                        onChange={handleChangeBankName}
                      />
                      <Select3
                        className="mt20 wmax472"
                        label="Country"
                        propName="0"
                        propValue="1"
                        value={countryCode}
                        onChange={handleChangeCountryCode}
                        items={COUNTRIES_UPPERCASE}
                        // error={clicked && invalidCountryCode}
                      />
                      <TextField
                        className="mt20 wmax472"
                        label="Account number"
                        value={accountNumber}
                        onChange={handleChangeAccountNumber}
                        // error={clicked && invalidAccountNumber}
                      />
                      <TextField
                        className="mt20 wmax472"
                        label="Bank code"
                        value={bankCode}
                        onChange={handleChangeBankCode}
                        // error={clicked && invalidBankCode}
                      />
                      <div className="mt20 f18 fw7">Nium routing data</div>
                      <TextField
                        className="mt20 wmax472"
                        label="Routing code type 1"
                        value={routingCodeType1}
                        onChange={handleChangeRoutingCodeType1}
                        // error={clicked && invalidRoutingCodeType1}
                      />
                      <TextField
                        className="mt20 wmax472"
                        label="Routing code value 1"
                        value={routingCodeValue1}
                        onChange={handleChangeRoutingCodeValue1}
                        // error={clicked && invalidRoutingCodeValue1}
                      />
                      <TextField
                        className="mt20 wmax472"
                        label="Routing code type 2"
                        value={routingCodeType2}
                        onChange={handleChangeRoutingCodeType2}
                        // error={clicked && invalidRoutingCodeType2}
                      />
                      <TextField
                        className="mt20 wmax472"
                        label="Routing code value 2"
                        value={routingCodeValue2}
                        onChange={handleChangeRoutingCodeValue2}
                        // error={clicked && invalidRoutingCodeValue2}
                      />
                      <TextField
                        className="mt20 wmax472"
                        label="Routing code type 3"
                        value={routingCodeType3}
                        onChange={handleChangeRoutingCodeType3}
                        // error={clicked && invalidRoutingCodeType3}
                      />
                      <TextField
                        className="mt20 wmax472"
                        label="Routing code value 3"
                        value={routingCodeValue3}
                        onChange={handleChangeRoutingCodeValue3}
                        // error={clicked && invalidRoutingCodeValue3}
                      />
                    </>
                  ) : (
                    <span />
                  )
                }
              </WrapperWithLoading>
            </Popup>
          );
        };
      });
    };

    const openIndividualWithdrawWindow = (data) => {
      openPopupWindow((setPopupState, popup) => {
        const {close} = popup;
        popup.state = {
          clicked: false,
          amount: data.available_amount || 0,
        };

        const handleProvider = changeProviderProvider(setPopupState);
        const handleChangeAmount = handleProvider('amount');

        return (stateOfPopup) => {
          const {
            amount,
          } = stateOfPopup;

          const amountNotSet = !amount;
          const amountBelowZeroSet = amount < 0;
          const amountAboveMax = amount > data.available_amount;
          const amountError = amountNotSet || amountBelowZeroSet || amountAboveMax;

          return (
            <Popup caption={(
              <div className="layoutRow fhaS fvaC w">
                <div>Create individual payment</div>
              </div>
            )}
            onCancel={close}
            disabled={stateOfPopup.clicked && amountError}
            onSave={() => {
              if (amountError) {
                setPopupState({
                  clicked: true,
                });
                return;
              }

              setPopupState({
                loading: true,
              });

              apiAdminPayoutVertoIndividualCreate({
                amount,
                merchant_id: data.merchant_id,
                fiat_code: data.currency,
              }).finally((error) => {
                setState({loading: false});
                update();
                close();
                openV1PopupInfo(['Success', 'Individual payment created!']);
              });
            }}
            >
              <WrapperWithLoading loading={stateOfPopup.loading}>
                <TextField
                  className="mt30 wmax471 mr10>1"
                  label="Payment amount"
                  value={amount}
                  // onChange={handleChangeAmount}
                  onChange={noop}
                  error={stateOfPopup.clicked && amountError}
                  helperText={
                    amountNotSet
                      ? 'Required field'
                      : amountBelowZeroSet
                        ? 'Amount must be higher than 0'
                        : amountAboveMax
                          ? `Amount must less or equal ${data.available_amount}`
                          : ''
                  }
                  disabled
                />
              </WrapperWithLoading>
            </Popup>
          );
        };
      });
    };

    const openMultipleWithdrawWindow = (selectedItems) => {
      openPopupWindow((setPopupState, popup) => {
        const {close} = popup;
        popup.state = {
          loading: false,
        };

        return (stateOfPopup) => {
          return (
            <Popup caption={(
              <div className="layoutRow fhaS fvaC w">
                <div>Create multiple payments</div>
              </div>
            )}
            text="Create"
            onCancel={close}
            onSave={() => {
              setPopupState({
                loading: true,
              });

              const requests = selectedItems.map((el) => {
                return apiAdminPayoutVertoIndividualCreate({
                  amount: el.available_amount,
                  merchant_id: el.merchant_id,
                  fiat_code: el.currency,
                })
              })

              Promise.all(requests).finally((error) => {
                setState({loading: false});
                update();
                close();
                openV1PopupInfo([
                  'Success',
                  selectedItems.length > 1
                    ? 'Payments created!'
                    : 'Payment created!'
                ]);
              });
            }}
            >
              <WrapperWithLoading loading={stateOfPopup.loading}>
                <div className="layoutRow fxwWrap mt15 mh-15 (w50%|ph15)>1">
                  {selectedItems.map((el, i) => (
                    <div key={i}>
                      <FieldC
                        label={el.email}
                        value={(
                          <DisplayAmountAdmin
                            amount={el.available_amount}
                            symbol={el.currency}
                            type="fiat"
                          />
                        )}
                      />
                    </div>
                  ))}
                </div>
              </WrapperWithLoading>
            </Popup>
          );
        };
      });
    };

    function Item({data}) {
      const merchantId = data.merchant_id || '';
      const name = data.name || '';
      const email = data.email || '';
      const lastWithdrawal = data.last_withdrawal_date || null;
      // const nextPayout = data.next_payout_expected_at || null;
      const currency = data.currency || '';
      const availableAmount = data.available_amount || '';
      const totalAmount = data.total_amount || '';

      const checkedMap = self.state.checkedMap || {};
      const checked = Boolean(checkedMap[merchantId]);

      return (
        <RowA className="f12">
          <ColA2 className="w50">
            <CheckboxB
              className="c65676D z1"
              checked={checked}
              onChange={() => {
                setState({
                  checkedMap: {
                    ...checkedMap,
                    [merchantId]: !checked,
                  },
                });
              }}
            />
          </ColA2>
          <ColA className="wmin155 fx1">
            <DisplayIdAdmin>
              {merchantId}
            </DisplayIdAdmin>
          </ColA>
          <ColA className="wmin155 fx1">
            <DisplayDataAdmin>{name}</DisplayDataAdmin>
          </ColA>
          <ColA className="wmin130 fx1">
            <DisplayDataAdmin>{email}</DisplayDataAdmin>
          </ColA>
          <ColA className="wmin130">
            <DisplayDateTimeAdmin date={lastWithdrawal} />
          </ColA>
          {/* <ColA className="wmin110">*/}
          {/*  <Tooltip className="mA>1" title={getRFC3339(nextPayout)}>*/}
          {/*    <div>{formatTime(nextPayout, '{dd} {mmm}, {yyyy}')}</div>*/}
          {/*    <div className="c717275 fw4 mt8">*/}
          {/*      {formatTime(nextPayout, '{hh}:{MM}:{ss} {TT}')}*/}
          {/*    </div>*/}
          {/*  </Tooltip>*/}
          {/* </ColA>*/}
          <ColA className="wmin150">
            <DisplayAmountAdmin
              amount={totalAmount}
              symbol={currency}
              type="fiat"
            />
          </ColA>
          <ColA className="wmin150">
            <DisplayAmountAdmin
              amount={availableAmount}
              symbol={currency}
              type="fiat"
            />
          </ColA>
          <ColA className="wmin150">
            {
              [
                'csmacro@csmacro.com',
                'v.beverlyhills@gmail.com',
                'support@icronpay.com'
              ].includes(email)
                ? 'Crypto'
                : 'Fiat'
            }
          </ColA>
          <ColA2 className="w50">
            <Tooltip title="Creates an individual payout via Verto for the selected merchant" disabledCopy>
              <Ripple
                className="w40 h40 p7 r7 (bgc0.25):h"
                onClick={() => {
                  openIndividualWithdrawWindow(data);
                }}
              >
                <PaymentIcon fill="#fff"/>
              </Ripple>
            </Tooltip>
          </ColA2>
          {/*<ColA2 className="w50">*/}
          {/*  <Tooltip title="Withdrawal" disabledCopy>*/}
          {/*    <Ripple*/}
          {/*      className="w40 h40 p7 r7 (bgc0.25):h"*/}
          {/*      onClick={() => {*/}
          {/*        openWithdrawalWindow([data]);*/}
          {/*      }}*/}
          {/*    >*/}
          {/*      <SendMoneyIcon/>*/}
          {/*    </Ripple>*/}
          {/*  </Tooltip>*/}
          {/*</ColA2>*/}
          <ColA2 className="w50">
            <Tooltip title="Edit Merchant Bank Account" disabledCopy>
              <Ripple
                className="w40 h40 p7 r7 (bgc0.25):h"
                onClick={() => {
                  openDetailsWindow(merchantId);
                }}
              >
                <PencilIcon className="w25 h25"/>
              </Ripple>
            </Tooltip>
          </ColA2>
        </RowA>
      );
    }

    const handleUpdateProviderProvider = (setState, update) => {
      return (field) => {
        return (value) => {
          setState({[field]: value});
          update && update();
        };
      };
    };
    const handleProvider = handleUpdateProviderProvider(setState, update);
    const handleChangeCurrency = handleProvider('currency');

    return (state) => {
      const data = state.data || {};
      const items = data.list || [];
      const checkedMap = state.checkedMap || {};
      const hasActiveAny = find(items, isChecked);
      const selected = items.filter((item) => checkedMap[item.merchant_id]);
      const hasActiveAll = items.length && every(items, isChecked);

      let selectedTotalAmount = 0;
      let selectedAvailableAmount = 0;
      let selectedCurrency = '';

      if (selected.length) {
        selectedCurrency = selected[0].currency;

        selected.forEach((el) => {
          selectedTotalAmount = selectedTotalAmount + Number(el.total_amount || 0);
          selectedAvailableAmount = selectedAvailableAmount + Number(el.available_amount || 0);
        })
      }

      // const rowHeight = self

      // const checkboxActionsPosition = items

      function isChecked(item) {
        return checkedMap[item.merchant_id];
      }


      const handlerCheckAll = () => {
        setState({
          checkedMap: reduce(items, (output, item) => {
            output[item.merchant_id] = !hasActiveAll;
            return output;
          }, {}),
        });
      };

      return (
        <LayoutA>
          <HeaderA>
            <Caption>Payout Merchants</Caption>

            <WrapperWithLoading loading={state.loading}>
              <div className="layoutRow fhaS fvaC">
                <ButtonD
                  className="wmin100 mr10"
                  onClick={() => {
                    pushLocation({
                      path: LINK_ADMIN_PAYOUT_NIUM_REMITTERS,
                    });
                  }}
                >
                  Remitters
                </ButtonD>
                <Select
                  className="w100 mr10 (hmin50|hmax50|h50)>.MuiInputBase-root*2
                  (bc00):not[.Mui-error]>.*OutlinedInput-notchedOutline*2"
                  propName="id"
                  propValue="id"
                  items={CURRENCY_ITEMS}
                  value={state.currency}
                  onChange={(e) => {
                    handleChangeCurrency(e);
                    setState({checkedMap: []})
                    update();
                  }}
                />
                <ButtonD
                  className="wmin100"
                  onClick={update}
                >
                  <RefreshIcon/>
                  <div className="pl15">Refresh</div>
                </ButtonD>
              </div>
            </WrapperWithLoading>
          </HeaderA>

          <div className="abs st70 sh-45 sb10 ov">
            <div className="ovxA abs s ph45 pb80">
              <div className="wmin1350 rlv h">
                <RowB
                  className={`f12 h66 ph50 pl40 r6 dn bg0.1.active h70 w100%+90 bc505255 cA4A7AC dn bc00.active` + hasActiveAny ? ' active' : ''}>
                  <ColB2 className="mA>1 w50 ph0*2">
                    <CheckboxB
                      className="c65676D"
                      checked={hasActiveAll}
                      onChange={handlerCheckAll}
                      disabled={!items.length}
                    />
                  </ColB2>
                  {/*{*/}
                  {/*  hasActiveAny ? (*/}
                  {/*    <ButtonQ*/}
                  {/*      className="ml40"*/}
                  {/*      onClick={() => {*/}
                  {/*        openWithdrawalWindow(selected);*/}
                  {/*      }}*/}
                  {/*    >Withdrawal selected ({selected.length})</ButtonQ>*/}
                  {/*  ) : (*/}
                      <>
                      <ColB className="wmin155 fx1">ID</ColB>
                      <ColB className="wmin155 fx1">Company name</ColB>
                      <ColB className="wmin130 fx1">Email</ColB>
                      <ColB className="wmin130">
                        Last<br/>withdrawal
                      </ColB>
                      {/* <ColB className="wmin110 tc">*/}
                      {/*  <Tooltip title="Optional datetime when next automatic payout is expected">*/}
                      {/*    Next payout*/}
                      {/*  </Tooltip>*/}
                      {/* </ColB>*/}
                      <ColB className="wmin150">Total</ColB>
                      <ColB className="wmin150">Available</ColB>
                      <ColB className="wmin150">Payout Type</ColB>
                      <ColB2 className="w50"/>
                      {/*<ColB2 className="w50"/>*/}
                      <ColB2 className="w50"/>
                    </>
                  {/*)*/}
                  {/*}*/}
                </RowB>
                <div className="abs st70 sh-45 sb10 ovH">
                  {render(Item)}
                </div>
              </div>
            </div>
            <ButtonUp
              show={state.showUp}
              onClick={self.handleToUp}
            />
            <div className={
              'w100%-380 h90 fixed sb0 sl355 layoutRow jcSB aiC ph25 rlt16 rrt16 bg04 xY100% dn (xY0).shown'
              + (!!selected.length ? ' shown' : '')
            }>
              <div>{selected.length} selected</div>
              <div className="layoutRow aiC mh-10 pr9 (ph10|f12)>1">
                <div className="wmin150">
                  <DisplayAmountAdmin
                    amount={selectedTotalAmount}
                    symbol={selectedCurrency}
                    type="fiat"
                  />
                </div>
                <div className="wmin150">
                  <DisplayAmountAdmin
                    amount={selectedAvailableAmount}
                    symbol={selectedCurrency}
                    type="fiat"
                  />
                </div>
                <div className="w60">
                  <Tooltip title="Withdrawal" disabledCopy>
                    <Ripple
                      className="w40 h40 p7 r7 (bgc0.25):h"
                      onClick={() => {
                        openMultipleWithdrawWindow(selected)
                      }}
                    >
                      <PaymentIcon fill="#fff"/>
                    </Ripple>
                  </Tooltip>
                </div>
                <div className="w60">
                  <Ripple
                    className="w40 h40 p7 r7"
                    disabled
                  >
                    <PencilIcon className="w25 h25 o10"/>
                  </Ripple>
                </div>
              </div>
            </div>
          </div>
        </LayoutA>
      );
    };
  },
});
